<template lang="pug">
  footer.grid
    //- pre.absolute.bg-white.top-0 {{ cart }}
    .cart-row
      .wrapper
        .left
          component.customer(
            v-if="isAuthenticated && member"
            :is="memberComponent.is"
            v-bind="memberComponent.props"
          ) {{ member.company || member.name }}
          Menu#footer-menu(k="footer-menu" :max-depth="1")
        .right
          //- button(@click="clearCart") CLEAR CART
          //- router-link.button.checkout(v-if="checkoutRoute && qty" :to="checkoutRoute")
          //-   span.icon
          //-     i.fas.fa-shopping-cart
          //-   span Checkout

          //- button.button.is-success.is-default.save-cart(@click="saveToDatabase")
          //-   span.icon
          //-     i.fas.fa-save
          //-   span Save Cart
          router-link.button.is-outlined.is-small(:to="{ name: 'order-check' }") Ordercheck
          BudgetingTool(v-if="isAuthenticated && member && shopID === 14")
    .actions
      ShoppingCart
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Menu from '@/components/Menu.vue';
import ShoppingCart from '@/extensions/shop/components/ShoppingCart';
import BudgetingTool from '@/extensions/shop/components/BudgetingTool';

import { get } from '@/helpers';

export default {
    name: 'CartRow',
    components: {
        Menu,
        ShoppingCart,
        BudgetingTool
    },
    computed: {
        userFormRoute() {
            let path;
            this.cms.menus.forEach(menu => {
                const item = menu.menuItems.find(item => get(item, 'page.view') === 'UserForm');
                if (item && item.path && !path) {
                    path = item.path;
                    return;
                }
            });
            return path;
        },
        memberComponent() {
            let memberComponent = {
                is: 'span',
                props: {}
            };
            if (this.userFormRoute) {
                memberComponent.is = 'router-link';
                memberComponent.props.to = this.userFormRoute;
            }
            return memberComponent;
        },
        shopID() {
            return parseInt(get(this.cms, 'shop.id', false));
        },
        ...mapGetters({
            member: 'auth/member',
            isAuthenticated: 'auth/isAuthenticated',
            // defaultTax: 'defaultTax',
            cms: 'CMS',
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            cart: 'shop/cart',
            menus: 'menus',
            config: 'config'
        })
    },
    methods: {
        ...mapActions({
            clearCart: 'shop/clearCart'
        })
    }
};
</script>
<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply hidden
  @screen lg
    @apply grid
    position: fixed
    bottom: 0
    background: rgba(255, 255, 255, .7)
    backdrop-filter: blur(30px)
    border-top: 1px solid var(--color-primary)
    width: 100%
    height: $footerHeight
    grid-template-rows: auto
    grid-template-columns: auto max-content
    z-index: 5
    @screen widescreen
      // grid-template-columns: minmax(0, $leftWidth) $rightWidth
      grid-template-columns: auto max-content
  .cart-row
    height: 100%
  .actions
    padding-right: 3rem
    ::v-deep
      .budgeting-tool
        padding-right: 0
  nav#footer-menu::v-deep
    // @apply mx-auto p-4 hidden
    display: none
    height: 100%
    align-items: center
    position: relative
    justify-content: flex-end
    @screen lg
      display: flex
    ul
      & > li
        border: 0
        display: inline-block
        & + li
          &:before
            content: "/"
            margin: 0 2px
        &.active .tree-item a
          // background: var(--color-primary)
          // --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
          // color: hsl(0, 0%, var(--switch))
        .tree-item
          display: inline-block
          a
            line-height: 1
            padding: 2px 5px 4px

  .wrapper
    display: flex
    justify-content: space-between
    padding: 0 3rem
    height: 100%
    align-items: center
    //- @screen lg
    //-   @screen widescreen
    //-     padding-right: 10rem
    .left
      display: flex
      align-items: center
      .customer
        padding-right: 3rem
        line-height: 36px
        font-weight: bold
    .right
      display: flex
      flex-direction: row
      align-items: center
      .checkout
        margin-right: 25px
        span
          color: white

  .actions
    display: flex
    align-items: center
    justify-content: flex-end

// .cart-row
//   display: none
//   position: fixed
//   bottom: 0
//   left: 0
//   width: 100%
//   z-index: 1
//   height: 50px
//   @screen lg
//     display: initial
</style>
